/**
 * Created by Abner Sui on 02/20/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { RefinebySubConfig, RefinebyObject, RefinebyOptionLimit, RefinebySubWidgetAction, RefinebyType } from './refineby-view.model';
import { Subscription } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { BriefConfig } from '../widgets.model';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'refineby-object',
    templateUrl: './refineby-object.component.html',
    styleUrls: ['./refineby-widget.component.scss']
})
export class RefinebyObjectComponent implements OnInit, OnDestroy {

    @Input()
    dataConfig: RefinebySubConfig;
    @Input()
    config: BriefConfig;

    isHoverOn = false;
    options: Array<RefinebyObject> = [];
    selectedOptions: Array<RefinebyObject> = [];
    categoryFilter: Object;
    hasEmptySelection = false;
    isIPAD: boolean;
    displayField = 'name';
    keyField = 'id';
    searchResult: Array<RefinebyObject>;
    optionLimit: number = RefinebyOptionLimit;

    private _categoryFilter: Array<string>;

    private _destroySubscriptions: Array<Subscription> = [];

    constructor(private _deviceService: DeviceDetectorService,
    ) { }

    ngOnInit() {
        this._destroySubscriptions.push(this.config.actionSubject$.subscribe(action => this._onSubscribeActions(action)));
        if (this.dataConfig.categoryId === 'noteType') {
            this.optionLimit = RefinebyOptionLimit * 2;
        }
        if (this.dataConfig.type === RefinebyType.entity) {
            if (this.dataConfig.status.showAsName) {
                this.displayField = 'longName';
            } else {
                this.displayField = 'shortName';
            }
        } else if (this.dataConfig.type === RefinebyType.text) {
            this.displayField = 'value';
            this.keyField = 'value';
        }
        this.options = this.dataConfig.options;
        this.options.sort((item1, item2) => {
            return item1[this.displayField].localeCompare(item2[this.displayField]);
        });
        this.selectedOptions = this.dataConfig.selectedOptions;
        this.selectedOptions.sort((item1, item2) => {
            return item1[this.displayField].localeCompare(item2[this.displayField]);
        });
        if (!this.dataConfig.isSearching) {
            this.selectedOptions.forEach(option => {
                option.checked = true;
                const index = this.options.findIndex(item => item[this.keyField] === option[this.keyField]);
                if (index > -1) {
                    option.count = this.options[index].count;
                    this.options.splice(index, 1);
                } else {
                    option.count = 0;
                    this.hasEmptySelection = true;
                }
            });
        }
        // For use within normal web clients
        this.isIPAD = this._deviceService.isMobile() || this._deviceService.isTablet();
        if (this.isIPAD) {
            this.isHoverOn = true;
        }
    }

    ngOnDestroy(): void {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    changeSelectedValue(item: RefinebyObject, event) {
        item.checked = !item.checked;
        let index: number;
        if (item.checked) {
            this.selectedOptions.push(item);
            this.selectedOptions.sort((item1, item2) => {
                return item1[this.displayField].localeCompare(item2[this.displayField]);
            });
            index = this.options.findIndex(data => data[this.keyField] === item[this.keyField]);
            this.options.splice(index, 1);
        } else {
            index = this.selectedOptions.findIndex(data => data[this.keyField] === item[this.keyField]);
            this.selectedOptions.splice(index, 1);
            this.options.push(item);
            this.options.sort((item1, item2) => {
                return item1[this.displayField].localeCompare(item2[this.displayField]);
            });
        }
        event.stopPropagation();
        this._categoryFilter = [];
        this.selectedOptions.forEach(option => {
            this._categoryFilter.push(option[this.keyField]);
        });
        this.config.feedbackSubject$.next({
            type: RefinebySubWidgetAction.SELECTED_OPTION_CHANGE,
            payload: {
                categoryId: this.dataConfig.categoryId,
                selectedOptions: this.selectedOptions,
                categoryFilter: this._categoryFilter
            }
        });
    }

    collapse() {
        this.dataConfig.status.collapsed = !this.dataConfig.status.collapsed;
        this.config.feedbackSubject$.next({
            type: RefinebySubWidgetAction.STATUS_CHANGE,
            payload: {
                categoryId: this.dataConfig.categoryId,
                status: this.dataConfig.status
            }
        });
        if (this.options && this.options.length > this.optionLimit && this.dataConfig.status.showMore) {
            this.onShowMore();
        }
    }

    onMeatball(event) {
        if (this.isIPAD) {
            event.clientX = event.pageX;
            event.clientY = event.pageY;
        }
        this.config.feedbackSubject$.next({
            type: RefinebySubWidgetAction.CLICK_MEATBALL,
            payload: {
                event: event,
                categoryId: this.dataConfig.categoryId
            }
        });
    }

    onMouseOver() {
        this.isHoverOn = true;
    }

    onMouseOut() {
        this.isHoverOn = false;
    }

    onShowMore() {
        this.dataConfig.status.showMore = !this.dataConfig.status.showMore;
        this.config.feedbackSubject$.next({
            type: RefinebySubWidgetAction.STATUS_CHANGE,
            payload: {
                categoryId: this.dataConfig.categoryId,
                status: this.dataConfig.status
            }
        });
    }

    private _onSubscribeActions(action) {
        if (action.type === RefinebySubWidgetAction.SEARCH) {
            this.searchResult = [];
            this.options.forEach(option => {
                if (option.checked || option[this.displayField].toLowerCase().includes(action.payload.toLowerCase())) {
                    this.searchResult.push(option);
                }
            });
            this.config.feedbackSubject$.next({
                type: RefinebySubWidgetAction.SEARCH_RESULT,
                payload: {
                    categoryId: this.dataConfig.categoryId,
                    searchResult: this.searchResult,
                }
            });
        } else if (action.type === RefinebySubWidgetAction.CHANGE_STATUS) {
            if (this.dataConfig.type === RefinebyType.entity) {
                if (this.dataConfig.status.showAsName) {
                    this.displayField = 'longName';
                } else {
                    this.displayField = 'shortName';
                }
            }
        }
    }

}
